import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//components
import {FountainLineItemEditComponent} from '../../components/Editors/FountainLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-fountainlineitem-grid',
  templateUrl: './FountainLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => FountainLineItemGridComponent)}]
})
export class FountainLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.FountainLineItem[] = [];
    selectedLineItems: ent.FountainLineItem[] = [];
    editedLineItem: ent.FountainLineItem;
    modelGroupFilter: filters.ModelGroupFilter;
    modelFilter: filters.ModelFilter;

    
    @ViewChild(FountainLineItemEditComponent) public fountainLineItemEdit: FountainLineItemEditComponent;
    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    
    modelGroups: ent.ModelGroup[] = [];
    models: ent.Model[] = [];
    equipmentGraphics: ent.EquipmentGraphics[] = [];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.editedLineItem = new ent.FountainLineItem();
        this.load();
    }

    public load(){
        this.modelGroupFilter = {SectionID: enums.Section.FountainLineItems};
        this.domainDataService.getModelGroups(this.modelGroupFilter).subscribe(x=> this.onGetModelGroupsDone(x));
        this.modelFilter = {SectionID: enums.Section.FountainLineItems};
        this.domainDataService.getModels(this.modelFilter).subscribe(x=> this.onGetModelsDone(x));
        var egFilter: filters.EquipmentGraphicsFilter = {};
        this.domainDataService.getEquipmentGraphics(egFilter).subscribe(x=> this.onGetEquipmentGraphicsDone(x));

        this.fountainLineItemEdit.modelGroupDropdown.filter = this.modelGroupFilter;
        this.fountainLineItemEdit.modelGroupDropdown.loadOnDemand();

        this.fountainLineItemEdit.modelDropdown.filter = this.modelFilter;
        this.fountainLineItemEdit.modelDropdown.loadOnDemand();

    }
    
    onGetModelGroupsDone(items: ent.ModelGroup[]){
        items.forEach(y=> this.modelGroups.push(y));
    }

    onGetModelsDone(items: ent.Model[]){
        items.forEach(y=> this.models.push(y));
    }

    onGetEquipmentGraphicsDone(items: ent.EquipmentGraphics[]){
        items.forEach(y=> this.equipmentGraphics.push(y));
      }
    
    onAddClick(event: any){
      
        this.editedLineItem = new ent.FountainLineItem();
        this.fountainLineItemEdit.lineItem = new ent.FountainLineItem();
        this.fountainLineItemEdit.modelDropdown.value = null;
        this.fountainLineItemEdit.modelGroupDropdown.value = null;
        this.fountainLineItemEdit.equipmentGraphicsDropdown.value = null;
        this.fountainLineItemEdit.displayDialog = true;

    }

    onDeleteClick(event: any, lineItem: ent.FountainLineItem){
        //alert(lineItem.Model.Name);
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onEditClick(event: any, lineItem: ent.FountainLineItem){
        
        this.editedLineItem = lineItem;
        this.fountainLineItemEdit.lineItem = lineItem;
        this.fountainLineItemEdit.modelDropdown.value = lineItem.ModelID;
        this.fountainLineItemEdit.modelGroupDropdown.value = lineItem.ModelGroupID;
        this.fountainLineItemEdit.equipmentGraphicsDropdown.value = this.editedLineItem.EquipmentGraphicsID;
        this.fountainLineItemEdit.displayDialog = true;
    }

    onFountainLineItemEditOK(){
        
        this.editedLineItem.ModelGroup = null;
        if (this.editedLineItem.ModelGroupID && this.editedLineItem.ModelGroupID > 0){
            var modelGroup = this.modelGroups.filter(x=>x.ID == this.editedLineItem.ModelGroupID)[0];
            this.editedLineItem.ModelGroup = {ID: modelGroup.ID, Name: modelGroup.Name, Inactive: false, NonSerialized: modelGroup.NonSerialized};
        }

        this.editedLineItem.Model = null;
        if (this.editedLineItem.ModelID && this.editedLineItem.ModelID > 0){
            var model = this.models.filter(x=>x.ID == this.editedLineItem.ModelID)[0];
            this.editedLineItem.Model = {ID: model.ID, Name: model.Name, Inactive: false};
        }

        this.editedLineItem.EquipmentGraphics = null;
        if (this.editedLineItem.EquipmentGraphicsID && this.editedLineItem.EquipmentGraphicsID > 0){
            var equipmentGraphics = this.equipmentGraphics.filter(x=>x.ID == this.editedLineItem.EquipmentGraphicsID)[0];
            this.editedLineItem.EquipmentGraphics = {ID: equipmentGraphics.ID, Name: equipmentGraphics.Name, Code: "", Inactive: equipmentGraphics.Inactive};
        }

        this.lineItems = <ent.FountainLineItem[]>this.addLineItem(this.editedLineItem, this.lineItems);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

}